(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["autoplay-video-rp"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const CASE_ID = localStorage.getItem("caseId") || null;
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  
  // Detect iOS
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  // iOS Mobile specific flag - videos require manual play
  const isIOSMobile = isIOS && isMobile;
  
  // Add class to wrapper for CSS targeting
  if (isIOSMobile) {
    document.querySelector('.real-stories-wrapper')?.classList.add('ios-mobile');
  }

  // Track global mute preference for the session
  let globalMutePreference = true;
  let userHasSetPreference = false;
  
  // Track if user has manually initiated playback (for iOS mobile)
  let userInitiatedPlayback = false;

  // Store video playback positions
  const videoPositions = new Map();

  function getVideoMeta(card) {
    const video = card.querySelector("video");
    return {
      videoURL: video?.dataset.videoUrl || "",
      videoTitle: card.querySelector("img")?.alt || ""
    };
  }

  const slider = $('.real-stories-slider');
  let activeCard = null;
  let hasStarted = false;
  let isSliderReady = false;
  let playlistEnded = false;
  let isUserSwiping = false;

  /* -------------------------
     GET CARD INDEX FOR SLICK
  ------------------------- */
  function getCardSlideIndex(card) {
    const index = card.getAttribute('data-index');
    if (index !== null) {
      return parseInt(index, 10);
    }
    
    const slides = slider.find('.slick-slide').not('.slick-cloned');
    let foundIndex = 0;
    
    slides.each(function(idx) {
      const $slide = $(this);
      let slideCard;
      if (this.hasAttribute('data-card')) {
        slideCard = this;
      } else {
        slideCard = $slide.find('[data-card]')[0];
      }
      if (slideCard === card) {
        foundIndex = idx;
        return false;
      }
    });
    
    return foundIndex;
  }

  /* -------------------------
     PRELOAD VIDEOS STRATEGICALLY
  ------------------------- */
  function preloadVideo(video, priority = false) {
    if (!video || video.readyState >= 3) return;
    
    if (!video.src && video.dataset.videoUrl) {
      video.src = video.dataset.videoUrl;
    }
    
    if (isIOS) {
      video.preload = "auto";
      video.load();
      
      if (priority && video.readyState < 3) {
        const loadHandler = () => {
          if (video.duration > 0) {
            video.currentTime = 0.1;
            video.removeEventListener('loadedmetadata', loadHandler);
          }
        };
        video.addEventListener('loadedmetadata', loadHandler);
      }
    } else {
      if (priority) {
        video.preload = "auto";
        video.load();
      } else {
        video.preload = "metadata";
      }
    }
  }

  function preloadAdjacentVideos(currentIndex) {
    const totalSlides = slider.slick('getSlick').slideCount;
    
    const indicesToPreload = [
      currentIndex,
      (currentIndex + 1) % totalSlides,
      (currentIndex - 1 + totalSlides) % totalSlides
    ];
    
    const slides = slider.find('.slick-slide').not('.slick-cloned');
    
    indicesToPreload.forEach((index, priority) => {
      const $slide = $(slides[index]);
      let card;
      if ($slide[0] && $slide[0].hasAttribute('data-card')) {
        card = $slide[0];
      } else {
        card = $slide.find('[data-card]')[0];
      }
      
      if (card) {
        const video = card.querySelector('video');
        preloadVideo(video, priority === 0);
        
        if (isIOS && priority === 1 && isUserSwiping) {
          if (!video.src && video.dataset.videoUrl) {
            video.src = video.dataset.videoUrl;
          }
          video.preload = "auto";
          video.load();
          video.currentTime = 0;
        }
      }
    });
  }

  /* -------------------------
     HARD AUTOPLAY (RESPECTS GLOBAL MUTE PREFERENCE)
  ------------------------- */
  function forceMutedPlay(video, card) {
    if (!video) return;
    
    video.muted = globalMutePreference;
    video.volume = globalMutePreference ? 0 : 1;
    if (globalMutePreference) {
      video.setAttribute("muted", "");
    } else {
      video.removeAttribute("muted");
    }
    
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('playsinline', '');
    
    const videoUrl = video.dataset.videoUrl;
    if (videoPositions.has(videoUrl)) {
      video.currentTime = videoPositions.get(videoUrl);
    }

    // Show video immediately - it should already be preloaded
    if (card) {
      const thumb = card.querySelector('.real-story-thumb');
      if (thumb) thumb.style.display = 'none';
      video.style.display = 'block';
    }

    const p = video.play();
    if (p) {
      p.catch((error) => {
        console.log('Play prevented:', error);
        // On iOS, retry once
        if (isIOS) {
          setTimeout(() => {
            video.play().catch(() => {});
          }, 50);
        }
      });
    }
  }

  function pauseAll() {
    if (activeCard) {
      const video = activeCard.querySelector("video");
      if (video && video.currentTime > 0) {
        const videoUrl = video.dataset.videoUrl;
        videoPositions.set(videoUrl, video.currentTime);
      }
    }

    $('[data-card]').each(function() {
      const video = $(this).find("video")[0];
      const thumb = $(this).find(".real-story-thumb")[0];
      
      $(this).removeClass('playing');
      
      if (video) {
        video.pause();
        video.style.display = "none";
      }
      if (thumb) {
        thumb.style.display = "block";
      }
    });
    activeCard = null;
  }

  function playCard(card, isManualClick = false) {
    if (!card) return;

    // For iOS mobile: only allow play if user manually clicked OR has previously initiated
    if (isIOSMobile && !isManualClick && !userInitiatedPlayback) {
      return;
    }

    pauseAll();

    const video = card.querySelector("video");
    const thumb = card.querySelector(".real-story-thumb");
    const muteBtn = card.querySelector("[data-mute]");

    if (!video || !thumb) return;

    card.classList.add('playing');
    
    // Ensure video source is set and loaded
    if (!video.src && video.dataset.videoUrl) {
      video.src = video.dataset.videoUrl;
    }
    
    // For iOS: keep thumbnail visible until video actually starts playing
    if (isIOSMobile) {
      // Position video behind thumbnail (invisible but ready)
      video.style.display = "block";
      video.style.position = "absolute";
      video.style.top = "0";
      video.style.left = "0";
      video.style.width = "100%";
      video.style.height = "100%";
      video.style.zIndex = "1";
      thumb.style.position = "relative";
      thumb.style.zIndex = "2";
      
      // Only hide thumbnail when video actually starts playing
      const onPlaying = () => {
        thumb.style.display = "none";
        video.style.position = "";
        video.style.zIndex = "";
        thumb.style.position = "";
        thumb.style.zIndex = "";
        video.removeEventListener('playing', onPlaying);
      };
      video.addEventListener('playing', onPlaying);
    } else {
      // Non-iOS: hide thumbnail immediately
      thumb.style.display = "none";
      video.style.display = "block";
    }

    forceMutedPlay(video, card);

    if (muteBtn) {
      if (globalMutePreference) {
        muteBtn.classList.remove("unmuted");
      } else {
        muteBtn.classList.add("unmuted");
      }
    }
    activeCard = card;
    
    if (isManualClick) {
      const meta = getVideoMeta(card);
      if (typeof fireVideoEvent !== 'undefined') {
        fireVideoEvent("rp_video_manual_play", CASE_ID, meta.videoURL, meta.videoTitle);
      }
    }
  }

  /* -------------------------
     MANUAL CLICK HANDLER
  ------------------------- */
  function handleCardClick(card, e) {
    // Don't trigger if clicking mute button
    if (e.target.closest('[data-mute]')) return;
    
    const video = card.querySelector("video");
    
    // If video is currently playing, pause it
    if (activeCard === card && video && !video.paused) {
      video.pause();
      const thumb = card.querySelector(".real-story-thumb");
      
      if (thumb) thumb.style.display = "block";
      video.style.display = "none";
      card.classList.remove('playing');
      activeCard = null;
      return;
    }
    
    // Mark that user has initiated playback (for iOS mobile autoplay on next videos)
    if (isIOSMobile) {
      userInitiatedPlayback = true;
    }
    
    // Reset playlist ended flag
    playlistEnded = false;
    
    // On mobile, first slide to this card's position, then play
    if (isMobile) {
      const cardIndex = getCardSlideIndex(card);
      const currentSlide = slider.slick('slickCurrentSlide');
      
      if (cardIndex !== currentSlide) {
        // Slide to this card first, then play after slide completes
        slider.one('afterChange', function() {
          setTimeout(() => {
            playCard(card, true);
          }, 50);
        });
        slider.slick('slickGoTo', cardIndex);
      } else {
        // Already on correct slide, just play
        playCard(card, true);
      }
    } else {
      // Desktop: just play
      playCard(card, true);
    }
  }

  /* -------------------------
     PREPARE VIDEOS
  ------------------------- */
  function setupVideoCard(card) {
    const video = card.querySelector("video");
    const muteBtn = card.querySelector("[data-mute]");

    if (!video) return;

    // Set video source immediately for all devices
    if (!video.src && video.dataset.videoUrl) {
      video.src = video.dataset.videoUrl;
    }
    
    video.loop = false;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.muted = globalMutePreference;
    
    // Preload more aggressively on iOS
    video.preload = "auto";
    
    if (globalMutePreference) {
      video.setAttribute("muted", "");
    }
    
    // Force load on iOS to ensure video is ready
    if (isIOS) {
      video.load();
    }

    if (video._endedHandler) {
      video.removeEventListener("ended", video._endedHandler);
    }

    const endedHandler = () => {
      const meta = getVideoMeta(card);
      if (typeof fireVideoEvent !== 'undefined') {
        fireVideoEvent("rp_video_completed", CASE_ID, meta.videoURL, meta.videoTitle);
      }
      
      const videoUrl = video.dataset.videoUrl;
      videoPositions.set(videoUrl, 0);
      video.currentTime = 0;
      
      // Stop current video and show thumbnail
      video.pause();
      const thumb = card.querySelector(".real-story-thumb");
      
      if (thumb) thumb.style.display = "block";
      video.style.display = "none";
      card.classList.remove('playing');
      activeCard = null;
      
      const currentSlideIndex = slider.slick('slickCurrentSlide');
      const totalSlides = slider.slick('getSlick').slideCount;
      
      if (currentSlideIndex === totalSlides - 1) {
        playlistEnded = true;
      } else {
        // Advance to next video (iOS mobile only if user initiated)
        if (!isIOSMobile || userInitiatedPlayback) {
          slider.slick('slickNext');
        }
      }
    };
    video._endedHandler = endedHandler;
    video.addEventListener("ended", endedHandler);

    if (muteBtn) {
      if (muteBtn._muteHandler) {
        muteBtn.removeEventListener("click", muteBtn._muteHandler);
      }

      const muteHandler = (e) => {
        e.stopPropagation();

        if (video.muted) {
          video.muted = false;
          video.volume = 1;
          video.removeAttribute("muted");
          muteBtn.classList.add("unmuted");
          globalMutePreference = false;
          userHasSetPreference = true;

          const meta = getVideoMeta(card);
          if (typeof fireVideoEvent !== 'undefined') {
            fireVideoEvent("rp_video_unmuted", CASE_ID, meta.videoURL, meta.videoTitle);
          }
        } else {
          video.muted = true;
          video.volume = 0;
          video.setAttribute("muted", "");
          muteBtn.classList.remove("unmuted");
          globalMutePreference = true;
          userHasSetPreference = true;
        }
      };
      muteBtn._muteHandler = muteHandler;
      muteBtn.addEventListener("click", muteHandler);
    }

    // Add click handler for manual play
    if (card._clickHandler) {
      card.removeEventListener("click", card._clickHandler);
    }
    
    const clickHandler = (e) => handleCardClick(card, e);
    card._clickHandler = clickHandler;
    card.addEventListener("click", clickHandler);
  }

  // Initialize slick
  slider.slick({
    slidesToShow: 4,
    dots: true,
    arrows: false,
    infinite: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, infinite: true } },
      { breakpoint: 768, settings: { slidesToShow: 1.5, infinite: false, centerMode: false } }
    ]
  });

  slider.on('swipe', function(event, slick, direction) {
    isUserSwiping = true;
    
    const currentSlide = slick.currentSlide;
    const nextSlide = direction === 'left' ? currentSlide + 1 : currentSlide - 1;
    preloadAdjacentVideos(nextSlide);
    
    setTimeout(() => {
      isUserSwiping = false;
    }, 1000);
  });

  setTimeout(() => {
    $('[data-card]').each(function() {
      setupVideoCard(this);
    });
    
    isSliderReady = true;
    preloadAdjacentVideos(0);
  }, 100);

  slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    if (activeCard) {
      const video = activeCard.querySelector("video");
      if (video) {
        const videoUrl = video.dataset.videoUrl;
        if (video.currentTime > 0) {
          videoPositions.set(videoUrl, video.currentTime);
        }
        video.pause();
      }
    }
    
    const slides = slider.find('.slick-slide').not('.slick-cloned');
    const $nextSlide = $(slides[nextSlide]);
    
    let nextCard;
    if ($nextSlide[0] && $nextSlide[0].hasAttribute('data-card')) {
      nextCard = $nextSlide[0];
    } else {
      nextCard = $nextSlide.find('[data-card]')[0];
    }
    
    if (nextCard && isIOS) {
      const nextVideo = nextCard.querySelector('video');
      if (nextVideo) {
        if (!nextVideo.src && nextVideo.dataset.videoUrl) {
          nextVideo.src = nextVideo.dataset.videoUrl;
        }
        nextVideo.preload = "auto";
        nextVideo.load();
        
        const loadHandler = () => {
          if (nextVideo.readyState >= 1) {
            nextVideo.currentTime = 0.01;
            nextVideo.removeEventListener('loadeddata', loadHandler);
          }
        };
        nextVideo.addEventListener('loadeddata', loadHandler);
      }
    }
    
    preloadAdjacentVideos(nextSlide);
  });

  if (isMobile) {
    slider.on('afterChange', function (event, slick, currentSlide) {
      const $currentSlide = $(slick.$slides[currentSlide]);
      
      let card = $currentSlide[0];
      if (!card.hasAttribute('data-card')) {
        card = $currentSlide.find('[data-card]')[0];
      }
      
      if (!card) return;

      const meta = getVideoMeta(card);
      if (typeof fireVideoEvent !== 'undefined') {
        fireVideoEvent("rp_video_scrolled", CASE_ID, meta.videoURL, meta.videoTitle);
      }

      playlistEnded = false;

      // For iOS mobile: only autoplay if user has initiated playback
      if (isIOSMobile) {
        if (userInitiatedPlayback) {
          const attemptPlay = () => {
            const video = card.querySelector('video');
            if (video && video.readyState >= 2) {
              playCard(card, false);
            } else {
              setTimeout(attemptPlay, 100);
            }
          };
          setTimeout(attemptPlay, 50);
        }
        // If user hasn't initiated on iOS, don't autoplay - wait for tap
      } else {
        // Non-iOS mobile (Android/Chrome): play immediately after slide change
        setTimeout(() => {
          playCard(card, false);
        }, 50);
      }
    });
  } else {
    // Desktop
    slider.on('afterChange', function (event, slick, currentSlide) {
      const visibleSlides = slider.find('.slick-slide.slick-active').not('.slick-cloned');
      const $firstSlide = $(visibleSlides[0]);
      
      let card;
      if ($firstSlide[0] && $firstSlide[0].hasAttribute('data-card')) {
        card = $firstSlide[0];
      } else {
        card = $firstSlide.find('[data-card]')[0];
      }
      
      if (!card) return;

      const meta = getVideoMeta(card);
      if (typeof fireVideoEvent !== 'undefined') {
        fireVideoEvent("rp_video_scrolled", CASE_ID, meta.videoURL, meta.videoTitle);
      }

      playlistEnded = false;

      setTimeout(() => {
        playCard(card, false);
      }, 50);
    });
  }

  /* -------------------------
     VIEWPORT OBSERVER
  ------------------------- */
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !hasStarted && isSliderReady) {
        hasStarted = true;

        let firstCard;
        if (isMobile) {
          const currentSlide = slider.slick('slickCurrentSlide');
          const slides = slider.find('.slick-slide').not('.slick-cloned');
          const $slide = $(slides[currentSlide]);
          
          if ($slide[0] && $slide[0].hasAttribute('data-card')) {
            firstCard = $slide[0];
          } else {
            firstCard = $slide.find('[data-card]')[0];
          }
        } else {
          const visibleSlides = slider.find('.slick-slide.slick-active').not('.slick-cloned');
          const $firstSlide = $(visibleSlides[0]);
          if ($firstSlide[0] && $firstSlide[0].hasAttribute('data-card')) {
            firstCard = $firstSlide[0];
          } else {
            firstCard = $firstSlide.find('[data-card]')[0];
          }
        }

        if (firstCard) {
          const meta = getVideoMeta(firstCard);
          if (typeof fireVideoEvent !== 'undefined') {
            fireVideoEvent("rp_video_component_viewed", CASE_ID, meta.videoURL, meta.videoTitle);
          }
          
          // iOS mobile: wait for manual tap, don't autoplay
          // Android/Chrome mobile & Desktop: autoplay first video
          if (!isIOSMobile) {
            playCard(firstCard, false);
          }
          // On iOS mobile, user needs to tap to start playing
        }
      }

      if (!entry.isIntersecting && activeCard) {
        const video = activeCard.querySelector("video");
        if (video) {
          const videoUrl = video.dataset.videoUrl;
          if (video.currentTime > 0) {
            videoPositions.set(videoUrl, video.currentTime);
          }
          video.pause();
        }
      }

      if (entry.isIntersecting && activeCard && hasStarted) {
        // Resume playing if section comes back into view
        // For iOS mobile: only resume if user has initiated playback
        if (!isIOSMobile || userInitiatedPlayback) {
          const video = activeCard.querySelector("video");
          if (video) {
            forceMutedPlay(video, activeCard);
          }
        }
      }
    });
  }, { threshold: 0.6 });

  const wrapper = document.querySelector(".real-stories-wrapper");
  if (wrapper) {
    observer.observe(wrapper);
  }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["centres-swirl-cdn"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  var $slider = $('#results-slider');
  var isSlickActive = false;

  // ---------- INIT SLICK FOR DESKTOP ----------
  function initSlick() {
    if (window.innerWidth > 768 && !isSlickActive) {
      $slider.slick({
        dots: true,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: false,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          }
        ]
      });
      isSlickActive = true;
    } else if (window.innerWidth <= 768 && isSlickActive) {
      $slider.slick('unslick');
      isSlickActive = false;
    }
  }

  // Initialize on load
  initSlick();

  // Handle resize
  var resizeTimer;
  $(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      initSlick();
    }, 250);
  });

  // ---------- STOP ALL VIDEOS ----------
  function stopAllVideos() {
    document.querySelectorAll(".results-section [data-card]").forEach(card => {
      const video = card.querySelector("[data-video]");
      const thumb = card.querySelector("[data-thumb]");
      const playBtn = card.querySelector("[data-play]");
      const overlay = card.querySelector("[data-overlay]");

      if (video) {
        video.pause();
        video.currentTime = 0;
        video.style.display = "none";
        video.removeAttribute("controls");
      }

      if (thumb) thumb.style.display = "block";
      if (playBtn) playBtn.style.display = "flex";
      if (overlay) overlay.style.display = "block";
    });
  }

  // ---------- CARD LOGIC ----------
  function initVideoCards() {
    document.querySelectorAll(".results-section [data-card]").forEach(card => {

      const video = card.querySelector("[data-video]");
      const videoURL = video ? video.dataset.videoUrl : null;
      const thumb = card.querySelector("[data-thumb]");
      const playBtn = card.querySelector("[data-play]");
      const overlay = card.querySelector("[data-overlay]");

      if (!video || !videoURL) return;

      // PLAY function
      function playVideo(e) {
        e.stopPropagation();
        stopAllVideos();

        if (!video.src) {
          video.src = videoURL;
          video.load();
        }

        if (thumb) thumb.style.display = "none";
        if (playBtn) playBtn.style.display = "none";
        if (overlay) overlay.style.display = "none";
        
        video.style.display = "block";
        video.setAttribute("controls", "controls");
        video.play();
      }

      // Click handlers
      if (playBtn) {
        playBtn.addEventListener("click", playVideo);
      }
      
      if (thumb) {
        thumb.addEventListener("click", playVideo);
      }

      // VIDEO END → reset
      video.addEventListener("ended", () => {
        video.style.display = "none";
        video.removeAttribute("controls");
        if (thumb) thumb.style.display = "block";
        if (playBtn) playBtn.style.display = "flex";
        if (overlay) overlay.style.display = "block";
      });

    });
  }

  initVideoCards();

  // Reinit video cards after slick events
  $slider.on('init reInit', function() {
    initVideoCards();
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-female-videos"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  const isFemaleResultPage = window.location.href.includes("female-result8");

  $('.rewamp-testimonial-videos-slider').slick({
    slidesToShow: isFemaleResultPage ? 1.5 : 4, // 👈 key change
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    focusOnSelect: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: isFemaleResultPage ? 1.5 : 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.5
        }
      }
    ]
  });

  const cards = document.querySelectorAll("[data-card]");

  cards.forEach(card => {
    const video = card.querySelector("[data-video]");
    const thumb = card.querySelector(".rewamp-testimonial-videos-thumb");
    const playBtn = card.querySelector("[data-play]");
    const pauseBtn = card.querySelector("[data-pause]");
    const videoURL = video.dataset.videoUrl;

    video.src = videoURL;
    video.preload = "metadata";

    function stopAllVideos() {
      document.querySelectorAll("[data-video]").forEach(v => {
        v.pause();
        v.style.display = "none";

        const c = v.parentElement;
        c.querySelector(".rewamp-testimonial-videos-thumb").style.display = "block";
        c.querySelector("[data-play]").style.display = "flex";
        c.querySelector("[data-pause]").classList.remove("show");
      });
    }

    playBtn.addEventListener("click", () => {
      stopAllVideos();
      const slideIndex = $(card).closest('.slick-slide').data('slick-index');
      $('.rewamp-testimonial-videos-slider').slick('slickGoTo', slideIndex);

      thumb.style.display = "none";
      playBtn.style.display = "none";

      video.style.display = "block";
      video.play();
    });

    thumb.addEventListener("click", () => playBtn.click());

    video.addEventListener("click", () => {
      video.pause();
      video.style.display = "none";
      thumb.style.display = "block";
      playBtn.style.display = "flex";
      pauseBtn.classList.remove("show");
    });

    video.onended = () => {
      video.style.display = "none";
      thumb.style.display = "block";
      playBtn.style.display = "flex";
      pauseBtn.classList.remove("show");
    };

    card.addEventListener("mouseenter", () => {
      if (!video.paused) pauseBtn.classList.add("show");
    });

    card.addEventListener("mouseleave", () => {
      pauseBtn.classList.remove("show");
    });

    pauseBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      video.pause();
      pauseBtn.classList.remove("show");
      playBtn.style.display = "flex";
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["optimized-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  // ---------- STOP ALL VIDEOS ----------
  function stopAllVideos() {
    document.querySelectorAll("[data-card]").forEach(function (card) {
      var video = card.querySelector("[data-video]");
      var thumb = card.querySelector(".real-story-thumb");
      var playBtn = card.querySelector("[data-play]");
      var pauseBtn = card.querySelector("[data-pause]");
      if (!video) return;

      video.pause();
      video.currentTime = 0;
      video.style.display = "none";
      thumb.style.display = "block";
      playBtn.style.display = "flex";
      pauseBtn.classList.remove("show");
    });
  }

  // ---------- CARD VIDEO LOGIC (unchanged) ----------
  document.querySelectorAll("[data-card]").forEach(function (card) {
    var video = card.querySelector("[data-video]");
    var videoURL = video.dataset.videoUrl;
    var thumb = card.querySelector(".real-story-thumb");
    var playBtn = card.querySelector("[data-play]");
    var pauseBtn = card.querySelector("[data-pause]");

    playBtn.addEventListener("click", function () {
      stopAllVideos();
      if (!video.src) { video.src = videoURL; video.load(); }
      thumb.style.display = "none";
      playBtn.style.display = "none";
      video.style.display = "block";
      video.play();
    });
    thumb.addEventListener("click", function () { playBtn.click(); });

    pauseBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      video.pause();
      pauseBtn.classList.remove("show");
    });

    video.addEventListener("pause", function () { pauseBtn.classList.remove("show"); });
    video.addEventListener("play", function () { pauseBtn.classList.remove("show"); });

    card.addEventListener("mouseenter", function () {
      if (!video.paused && !video.ended) pauseBtn.classList.add("show");
    });
    card.addEventListener("mouseleave", function () { pauseBtn.classList.remove("show"); });

    video.addEventListener("ended", function () {
      video.style.display = "none";
      thumb.style.display = "block";
      playBtn.style.display = "flex";
      pauseBtn.classList.remove("show");
    });
  });

  // ---------- SCROLL SLIDER + DOTS ----------
  document.querySelectorAll(".real-stories-slider").forEach(function (track) {
    var dotsWrap = track.parentElement.querySelector(".real-stories-dots");
    var cards = track.querySelectorAll(".real-story-card");
    if (!dotsWrap || !cards.length) return;

    var pageWidth = 0, pages = 1, scrollTimer = null, resizeTimer = null;

    function metrics() {
      var cardW = cards[0].offsetWidth;
      var cs = getComputedStyle(track);
      var gap = parseInt(cs.columnGap || cs.gap || 16, 10) || 16;
      var perView = Math.max(1, Math.round((track.clientWidth + gap) / (cardW + gap)));
      pageWidth = perView * (cardW + gap);
      pages = Math.max(1, Math.ceil(cards.length / perView));
    }

    function updateActive() {
      var active = Math.round(track.scrollLeft / pageWidth);
      if (active < 0) active = 0;
      if (active > pages - 1) active = pages - 1;
      var btns = dotsWrap.children;
      for (var i = 0; i < btns.length; i++) {
        btns[i].classList.toggle("is-active", i === active);
      }
    }

    function buildDots() {
      dotsWrap.innerHTML = "";
      for (var i = 0; i < pages; i++) {
        var b = document.createElement("button");
        b.type = "button";
        b.setAttribute("aria-label", "Go to group " + (i + 1));
        (function (idx) {
          b.addEventListener("click", function () {
            track.scrollTo({ left: idx * pageWidth, behavior: "smooth" });
          });
        })(i);
        dotsWrap.appendChild(b);
      }
      updateActive();
    }

    track.addEventListener("scroll", function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        updateActive();
        stopAllVideos();   // pause any playing video when the user scrolls
      }, 90);
    }, { passive: true });

    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { metrics(); buildDots(); }, 150);
    });

    metrics();
    buildDots();
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item') && html.querySelectorAll('.grid__item').length > 3) {
              console.log(html.querySelectorAll('.grid__item').length, 'legth')
              this.classList.add('product-recommendations--loaded');
               $(document).ready(function(){
                setTimeout(function(){
                  $('.product-recommendations .grid').slick({
                    infinite: true,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [
                      {
                        breakpoint: 769,
                        settings: {
                          slidesToShow: 1,
                          slidesToScroll: 1,
                          infinite: true,
                          dots: false
                        }
                      }
                    ]
                  });
                },10);
              });
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-videos"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  $('.real-stories-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    infinite: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    focusOnSelect: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 1.5 } }
    ]
  });

  const cards = document.querySelectorAll("[data-card]");

  cards.forEach(card => {
    const video = card.querySelector("[data-video]");
    const thumb = card.querySelector(".real-story-thumb");
    const playBtn = card.querySelector("[data-play]");
    const pauseBtn = card.querySelector("[data-pause]");
    const videoURL = video.dataset.videoUrl;
    video.src = videoURL;
    video.preload = "metadata";

    function stopAllVideos() {
      document.querySelectorAll("[data-video]").forEach(v => {
        v.pause();
        v.style.display = "none";

        const c = v.parentElement;
        c.querySelector(".real-story-thumb").style.display = "block";
        c.querySelector("[data-play]").style.display = "flex";
        c.querySelector("[data-pause]").classList.remove("show");
      });
    }

    playBtn.addEventListener("click", () => {
      stopAllVideos();
      const slideIndex = $(card).closest('.slick-slide').data('slick-index');
      $('.real-stories-slider').slick('slickGoTo', slideIndex);
      thumb.style.display = "none";
      playBtn.style.display = "none";

      video.style.display = "block";
      video.play();  // no delay now
    });

    thumb.addEventListener("click", () => playBtn.click());

    // click video to close
    video.addEventListener("click", () => {
      video.pause();
      video.style.display = "none";
      thumb.style.display = "block";
      playBtn.style.display = "flex";
      pauseBtn.classList.remove("show");
    });

    // reset at end
    video.onended = () => {
      video.style.display = "none";
      thumb.style.display = "block";
      playBtn.style.display = "flex";
      pauseBtn.classList.remove("show");
    };

    card.addEventListener("mouseenter", () => {
      if (!video.paused) pauseBtn.classList.add("show");
    });

    card.addEventListener("mouseleave", () => {
      pauseBtn.classList.remove("show");
    });

    pauseBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      video.pause();
      pauseBtn.classList.remove("show");
      playBtn.style.display = "flex";
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["traya-treatment-faq-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.traya-faq');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var trigger = section.querySelector('[data-popup-open]');
      var popup = section.querySelector('[data-popup]');
      if (!trigger || !popup) return;

      // Portal the popup to <body> so it escapes any ancestor stacking context
      // (transform/filter/isolation/etc.) that would otherwise trap its z-index.
      if (popup.parentElement !== document.body) {
        document.body.appendChild(popup);
      }

      var closers = popup.querySelectorAll('[data-popup-close]');
      var lastFocused = null;

      // Track scroll position when popup opens. Once body is position:fixed,
      // its scroll is reset to 0 — without restoring this on close, the user
      // ends up at the top of the page on mobile.
      var savedScrollY = 0;

      function getFocusable() {
        return popup.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
      }

      function openPopup() {
        lastFocused = document.activeElement;

        // Save scroll position BEFORE locking, then pin body with negative top
        // so the page visually stays in place.
        savedScrollY = window.scrollY || window.pageYOffset || 0;
        document.body.style.top = '-' + savedScrollY + 'px';

        popup.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('traya-faq-locked');
        document.addEventListener('keydown', onKeydown);

        // preventScroll: true stops mobile browsers from scrolling the
        // newly-focused close button into view, which causes the visible
        // "jump to top" symptom.
        var closeBtn = popup.querySelector('.traya-faq__close');
        if (closeBtn) {
          try { closeBtn.focus({ preventScroll: true }); }
          catch (e) { closeBtn.focus(); }
        }
      }

      function closePopup() {
        popup.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('traya-faq-locked');

        // Strip the inline negative top and restore the saved scroll position.
        document.body.style.top = '';
        window.scrollTo(0, savedScrollY);

        document.removeEventListener('keydown', onKeydown);

        if (lastFocused && typeof lastFocused.focus === 'function') {
          try { lastFocused.focus({ preventScroll: true }); }
          catch (e) { lastFocused.focus(); }
        }
      }

      function onKeydown(e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
          closePopup();
          return;
        }
        if (e.key === 'Tab' || e.keyCode === 9) {
          var focusables = getFocusable();
          if (!focusables.length) return;
          var first = focusables[0];
          var last = focusables[focusables.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }

      trigger.addEventListener('click', openPopup);
      closers.forEach(function (el) {
        el.addEventListener('click', closePopup);
      });

      document.addEventListener('shopify:section:unload', function (e) {
        if (e.detail && e.detail.sectionId === section.dataset.sectionId) {
          closePopup();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
